(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var root = document.querySelector('[data-sp-deal-popup]');
    if (!root) return;

    var dialog = root.querySelector('.sp-deal-popup__dialog');
    var reopen = root.querySelector('[data-sp-deal-reopen]');
    var closeButtons = root.querySelectorAll('[data-sp-deal-close]');
    var copyButton = root.querySelector('[data-sp-copy-code]');
    var success = Boolean(root.querySelector('[data-sp-deal-success]'));
    var delay = Math.max(0, parseInt(root.getAttribute('data-delay'), 10) || 0);
    var dismissDays = Math.max(1, parseInt(root.getAttribute('data-dismiss-days'), 10) || 7);
    var code = root.getAttribute('data-discount-code') || '';
    var storageKey = 'shadowsDealPopupDismissedAt';
    var lastFocused = null;
    var previousOverflow = '';
    var openState = false;

    function safelyGetDismissedAt() {
      try { return parseInt(window.localStorage.getItem(storageKey), 10) || 0; }
      catch (error) { return 0; }
    }

    function safelySetDismissedAt() {
      try { window.localStorage.setItem(storageKey, String(Date.now())); }
      catch (error) { /* Closing still works when storage is unavailable. */ }
    }

    function wasRecentlyDismissed() {
      var dismissedAt = safelyGetDismissedAt();
      return dismissedAt > 0 && (Date.now() - dismissedAt) < dismissDays * 86400000;
    }

    function getFocusable() {
      if (!dialog) return [];
      return Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function openPopup() {
      if (openState) return;
      openState = true;
      lastFocused = document.activeElement;
      previousOverflow = document.body.style.overflow;
      root.hidden = false;
      root.classList.remove('is-tab-only');
      reopen.hidden = true;
      document.body.style.overflow = 'hidden';

      window.requestAnimationFrame(function () {
        var focusable = getFocusable();
        if (focusable.length) focusable[0].focus();
        else if (dialog) dialog.focus();
      });
    }

    function showReopenTab() {
      root.hidden = false;
      root.classList.add('is-tab-only');
      reopen.hidden = false;
    }

    function closePopup(remember) {
      if (!openState) { showReopenTab(); return; }
      openState = false;
      document.body.style.overflow = previousOverflow;
      if (remember) safelySetDismissedAt();
      showReopenTab();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    Array.prototype.forEach.call(closeButtons, function (button) {
      button.addEventListener('click', function () { closePopup(true); });
    });

    reopen.addEventListener('click', openPopup);

    document.addEventListener('keydown', function (event) {
      if (!openState) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (copyButton && code) {
      copyButton.addEventListener('click', function () {
        var original = copyButton.textContent;
        function confirmCopy() {
          copyButton.textContent = 'Copied';
          window.setTimeout(function () { copyButton.textContent = original; }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(confirmCopy).catch(function () { window.prompt('Copy this discount code:', code); });
        } else {
          window.prompt('Copy this discount code:', code);
        }
      });
    }

    if (success) window.setTimeout(openPopup, 0);
    else if (wasRecentlyDismissed()) showReopenTab();
    else window.setTimeout(openPopup, delay);
  });
})();
